//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import userChecks from '~/mixins/userChecks';
export default {
	mixins: [userChecks],
	async fetch() {
		await Promise.all([ 
			this.$store.dispatch('resourcesStore/getResources', this.queries.sexlinks),
			this.$store.dispatch('pagesStore/getPage', 'sexlink')
		])
	},
	head() {
		return {
			title: this.pages.sexlink && this.pages.sexlink.seo ? this.pages.sexlink.seo.title : 'Sex Link Partners | Meiden van Holland',
			meta: [
				{ hid: 'title', name: 'title', content: this.pages.sexlink && this.pages.sexlink.seo ? this.pages.sexlink.seo.title : 'Sex Link Partners | Meiden van Holland' },
				{ hid: 'og:title', name: 'og:title', content: this.pages.sexlink && this.pages.sexlink.seo ? this.pages.sexlink.seo.title : 'Sex Link Partners | Meiden van Holland' },
				{ hid: 'description', name: 'description', content: this.pages.sexlink && this.pages.sexlink.seo ? this.pages.sexlink.seo.description : 'Ontdek alle sex link partners van Meiden van Holland. Geile vrienden rondom verschillende sexuele onderwerpen vind je hier.'},
				{ hid: 'og:description', name: 'og:description', content: this.pages.sexlink && this.pages.sexlink.seo ? this.pages.sexlink.seo.description : 'Ontdek alle sex link partners van Meiden van Holland. Geile vrienden rondom verschillende sexuele onderwerpen vind je hier.' },
				{ hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/info/sex-link-partners' },
				{ hid: 'keywords', name: 'keywords', content: this.pages.sexlink && this.pages.sexlink.seo ? this.pages.sexlink.seo.keywords : 'Sex Link Partners, links, websites'},
			]
		}
	},
	components: {
		dummy: () => import('~/components/content/dummy/default'),
		sexlink: () => import('~/components/content/sexlink/sexlink'),
		modal: () => import('~/components/content/sexlink/sexlink_readmore'),
		banner: () => import('~/components/banner')
	},
	computed: {
		...mapState({
			queries: ({ resourcesStore: {queries} }) => queries,
			pages: ({ pagesStore: {pages} }) => pages,
			sexlinks: ({ resourcesStore: {sexlinks} }) => sexlinks,
			modal: ({ modalStore: {modal} }) => modal,
			loading: ({ resourcesStore: { loading } }) => loading
		}),
	}
}
